import { jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, ButtonLink, IconNewWindow } from "braid-design-system";
import { translations } from "../../../components/.vocab/index.mjs";
import { applyButton } from "../JobDetailsView/JobDetailsView.css.mjs";
const noop = () => {
};
const ApplyButton = ({
  job,
  ctas,
  shouldOpenApplyInNewTab,
  size = "standard"
}) => {
  const { t } = useTranslations(translations);
  return job.isExpired ? null : /* @__PURE__ */ jsx(Box, { className: applyButton, width: "full", children: /* @__PURE__ */ jsx(
    ButtonLink,
    {
      href: job.applyUrl,
      onClick: (ctas == null ? void 0 : ctas.onApplyClick) ?? noop,
      tone: "brandAccent",
      target: job.isLinkOut || shouldOpenApplyInNewTab ? "_blank" : "",
      icon: job.isLinkOut ? /* @__PURE__ */ jsx(IconNewWindow, { alignY: "lowercase" }) : void 0,
      iconPosition: "trailing",
      "data-automation": "job-detail-apply",
      "aria-label": t("Apply for {jobTitle} at {jobCompanyName}", {
        jobTitle: job.title,
        jobCompanyName: job.company.name
      }),
      size,
      children: job.isLinkOut ? t("Apply") : t("Quick apply")
    }
  ) });
};
export {
  ApplyButton
};
